import React from 'react'
import {
  Card,
  CardContent,
  Box,
  Typography,
  LinearProgress,
  Chip,
  Grid
} from '@mui/material'

const GamifiedRegionCard = ({ region }) => {
  // Get color based on rank
  const getCardColor = (rank) => {
    if (rank === 1) return 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
    if (rank === 2) return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
    if (rank === 3) return 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'
    return 'linear-gradient(135deg, #f97316 0%, #fb923c 100%)' // Orange gradient
  }

  const cardBg = getCardColor(region.rank)

  return (
    <Card
      sx={{
        background: cardBg,
        color: 'white',
        height: '100%',
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'visible',
        '&:hover': {
          transform: 'scale(1.03)',
          boxShadow: 8,
        }
      }}
    >
      {/* Rank Badge */}
      <Box
        sx={{
          position: 'absolute',
          top: -15,
          right: -15,
          width: 60,
          height: 60,
          borderRadius: '50%',
          background: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '1.5rem',
          color: '#333',
          boxShadow: 4,
          zIndex: 1
        }}
      >
        {region.medal || `#${region.rank}`}
      </Box>

      <CardContent sx={{ pt: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, textAlign: 'center' }}>
          {region.region_name}
        </Typography>

        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography variant="h2" sx={{ fontWeight: 'bold', mb: 1 }}>
            {region.total_sales.toLocaleString()}
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            sztuk sprzedanych
          </Typography>
        </Box>

        <Grid container spacing={1} sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <Box
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(10px)',
                borderRadius: 2,
                p: 2,
                textAlign: 'center'
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                {region.district_count}
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                Dystryktów
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(10px)',
                borderRadius: 2,
                p: 2,
                textAlign: 'center'
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                {region.tempo}
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                Tempo
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mb: 2 }}>
          <Chip
            label={`${region.tier.icon} ${region.tier.name}`}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.3)',
              color: 'white',
              fontWeight: 'bold',
              width: '100%',
              fontSize: '1rem',
              height: 40,
              backdropFilter: 'blur(10px)'
            }}
          />
        </Box>

        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="caption" sx={{ opacity: 0.9 }}>
              vs Średnia
            </Typography>
            <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
              {region.vsAverage > 0 ? '+' : ''}{region.vsAverage}%
            </Typography>
          </Box>
          <Box
            sx={{
              height: 8,
              borderRadius: 4,
              backgroundColor: 'rgba(255, 255, 255, 0.3)',
              overflow: 'hidden'
            }}
          >
            <Box
              sx={{
                height: '100%',
                width: `${Math.min(Math.abs(region.vsAverageNum), 100)}%`,
                backgroundColor: region.vsAverageNum >= 0 ? '#4CAF50' : '#f44336',
                transition: 'width 0.5s ease'
              }}
            />
          </Box>
        </Box>

        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="caption" sx={{ opacity: 0.9 }}>
              % od lidera
            </Typography>
            <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
              {region.progressPercent.toFixed(1)}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={region.progressPercent}
            sx={{
              height: 8,
              borderRadius: 4,
              backgroundColor: 'rgba(255, 255, 255, 0.3)',
              '& .MuiLinearProgress-bar': {
                backgroundColor: 'white',
                borderRadius: 4,
              }
            }}
          />
        </Box>
      </CardContent>
    </Card>
  )
}

export default GamifiedRegionCard

